export default __webpack_public_path__ + "static/media/google.40c3ca32.svg";